import { ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    title: "Tell Us What You Need",
    copy: "Complete the service request form or contact TSM Group CLE.",
  },
  {
    num: "02",
    title: "We Review the Request",
    copy: "TSM determines the appropriate service, required documents, location, scheduling needs, and next steps.",
  },
  {
    num: "03",
    title: "Get the Service Completed",
    copy: "Services may be delivered virtually, at a designated location, or onsite depending on the service requested.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="bg-white py-24 lg:py-32">
    <div className="container-tsm">
      <FadeIn className="max-w-2xl">
        <p className="eyebrow">How It Works</p>
        <h2
          className="mt-6 font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl"
          data-testid="how-it-works-headline"
        >
          From Request to Completed Service
        </h2>
      </FadeIn>

      <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8" data-testid="how-it-works-steps">
        {STEPS.map((step, i) => (
          <FadeIn key={step.num} delay={i * 0.12}>
            <div className="group border-t-2 border-navy/10 pt-7 transition-colors duration-300 hover:border-gold" data-testid={`how-it-works-step-${i + 1}`}>
              <span className="font-mono text-sm font-semibold tracking-[0.2em] text-gold" aria-hidden="true">
                {step.num}
              </span>
              <h3 className="mt-4 font-serif text-2xl font-semibold text-navy lg:text-[1.7rem]">{step.title}</h3>
              <p className="mt-3 leading-relaxed text-ink/65">{step.copy}</p>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.3}>
        <div className="mt-14 flex justify-center">
          <a href="#request" data-testid="how-it-works-cta" className="btn-outline">
            Start a Service Request
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </FadeIn>
    </div>
  </section>
);
